export default __webpack_public_path__ + "static/media/pangong1.64725cf7.jpg";